import axios from 'axios';

import { getActiveWorkspaceId } from '@/stores/workspace-store';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001';

/**
 * Shared axios instance with workspace header interceptor
 *
 * Automatically adds X-Workspace-Id header from Zustand store.
 * This enables multi-workspace support without changing every API call.
 *
 * Backend middleware validates membership and overrides req.user.workspaceId,
 * so all existing code continues to work unchanged.
 */
export const apiClient = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add workspace header from store
apiClient.interceptors.request.use((config) => {
  const workspaceId = getActiveWorkspaceId();
  if (workspaceId) {
    config.headers['X-Workspace-Id'] = workspaceId;
  }
  return config;
});

/**
 * Helper to create auth headers with workspace support
 * Use this when making direct axios calls (not using apiClient)
 */
export function createAuthHeaders(token: string): Record<string, string> {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };

  const workspaceId = getActiveWorkspaceId();
  if (workspaceId) {
    headers['X-Workspace-Id'] = workspaceId;
  }

  return headers;
}

/**
 * Get the API base URL
 */
export function getApiUrl(): string {
  return API_URL;
}
